module.exports = __webpack_public_path__ + "img/plumbing-repair-03-xxlarge.c0e68928.jpg";